// How they define the bond
export const RELATIONSHIP_TYPES = [
  "married",
  "engaged",
  "domestic_partners_or_civil_union",
  "committed_relationship_long_term",
  "committed_relationship_new",
  "dating_casually",
  "co_parents_romantically_involved",
  "co_parents_platonic",
  "life_partners_or_nesting_partners",
];

// How that bond is doing right now
export const RELATIONSHIP_STATUSES = [
  "active_and_secure",
  "exploring_or_questioning",
  "newly_formed",
  "inactive_on_hold",
  "complicated_or_navigating_challenges",
  "open_to_exploration",
  "selectively_open",
  "temporarily_paused",
];